import { a as a$1 } from './chunk-H7LXVQOY.js';
import { a } from './chunk-5HWZQ4DE.js';
import * as e from '@radix-ui/react-checkbox';
import * as t from 'react';
import { jsx } from 'react/jsx-runtime';

var m=t.forwardRef(({className:c,...a$2},s)=>jsx(e.Root,{ref:s,className:a("peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",c),...a$2,children:jsx(e.Indicator,{className:a("flex items-center justify-center text-current"),children:jsx(a$1.Check,{className:"h-4 w-4"})})}));m.displayName=e.Root.displayName;

export { m as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-DDXNTG7W.js.map